import { useQuery } from '@tanstack/react-query'
import { parseQueryParams } from '../../../utilities/parsers'
import apiUrl from '../../../apis/api.url'
import { getData } from '../../../apis/api.helpers'
import { useAuthStore } from '../../../store/authStore'

const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}

const fetchCareers = async () => {
  const url = buildUrlWithParams(apiUrl.CAREER_LIST)
  const response = await getData(url)
  return response
}
export const useCareersList = () => {
  return useQuery(['careers_listing'], () => fetchCareers(), {
    refetchOnWindowFocus: false,
  })
}
const fetchRti = async () => {
  const url = buildUrlWithParams(apiUrl.RTI)
  const response = await getData(url)
  return response
}
const fetchRtiUser = async () => {
  const url = buildUrlWithParams(apiUrl.RTI_USER)
  const response = await getData(url)
  return response
}

export const useRti = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['rti_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchRtiUser()
      } else {
        return fetchRti()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchPublicationCommon = async () => {
  const url = buildUrlWithParams(apiUrl.PUBLICATION_COMMON)
  const response = await getData(url)
  return response
}
const fetchPublicationUser = async () => {
  const url = buildUrlWithParams(apiUrl.PUBLICATION_USER)
  const response = await getData(url)
  return response
}

export const useActsRules = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['publications_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchPublicationUser()
      } else {
        return fetchPublicationCommon()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}

const fetchTenders = async () => {
  const url = buildUrlWithParams(apiUrl.TENDERS)
  const response = await getData(url)
  return response
}
export const useTenders = () => {
  return useQuery(['tenders_listing'], () => fetchTenders(), {
    refetchOnWindowFocus: false,
  })
}
